import { Button } from "@aws-amplify/ui-react";
import { CTable } from "@coreui/react";
import { FiArrowLeft, FiArrowRight } from "react-icons/fi";
import LocalizedStrings from "react-localization";

const DevicesTable = ({ columns, items, pagination, onNext, onPrevious }) => {
  return (
    <>
      <CTable
        className="table-centered"
        items={items}
        columns={columns}
        tableHeadProps={{ color: "light" }}
        responsive
        hover
      />
      <Button
        size="small"
        disabled={pagination.previous?.length <= 0}
        style={styles.buttonPrevious}
        onClick={onPrevious}
      >
        <FiArrowLeft /> {strings.table.pagination.buttonPrevious}
      </Button>
      <Button
        size="small"
        disabled={!pagination.nextToken}
        style={styles.buttonNext}
        onClick={onNext}
      >
        <FiArrowRight /> {strings.table.pagination.buttonNext}
      </Button>
    </>
  );
};

const strings = new LocalizedStrings({
  es: {
    table: {
      pagination: {
        buttonPrevious: "Atrás",
        buttonNext: "Siguiente",
      },
    },
  },
});

const styles = {
  buttonPrevious: { marginLeft: "15px" },
  buttonNext: { float: "right", marginRight: "15px" },
};

export default DevicesTable;
